import type {ConferenceApiModel} from '../../../api/conference';
import type {CourseApiModel} from '../../../api/course';
import type {ApiListResponse} from '../../../api/types';
import type {CoreClientConferencesListParams} from '../../../api/types/core/methods';

import {apiRequest} from '../../../api/utils/apiRequest';
import {type TimeRange, timestampToDateTimeObj} from '../../../utils/datetime';
import {isConferenceExpired} from '../../../utils/entity/conference';

export const getBookedConferences = async (
  course: CourseApiModel,
  range: TimeRange,
) => {
  const query: CoreClientConferencesListParams['query'] = [
    ['course_id', '==', course._id],
    ['start_date', '>', timestampToDateTimeObj(range.start)],
    ['end_date', '<=', timestampToDateTimeObj(range.end)],
    ['billing_type', '!=', 'intro'],
    course.client_id ? ['client_id', '==', course.client_id] : null,
  ].filter(Boolean) as CoreClientConferencesListParams['query'];

  const {_items}: ApiListResponse<ConferenceApiModel> =
    await apiRequest<CoreClientConferencesListParams>({
      method: 'client.conferences.list',
      params: {
        query,
      },
    });

  return _items.filter(conference => !isConferenceExpired(conference));
};

/** Intro sessions are counted for the whole course (no cycle date range). */
export const getBookedIntroConferences = async (course: CourseApiModel) => {
  const query: CoreClientConferencesListParams['query'] = [
    ['course_id', '==', course._id],
    ['billing_type', '==', 'intro'],
    course.client_id ? ['client_id', '==', course.client_id] : null,
  ].filter(Boolean) as CoreClientConferencesListParams['query'];

  const {_items}: ApiListResponse<ConferenceApiModel> =
    await apiRequest<CoreClientConferencesListParams>({
      method: 'client.conferences.list',
      params: {
        query,
      },
    });

  return _items.filter(
    conference =>
      conference.status === 'ongoing' ||
      conference.status === 'past' ||
      (conference.status === 'upcoming' && !isConferenceExpired(conference)),
  );
};
